<template>
  <div>
    <!-- Hamburger Menu -->
    <div class="hamburger-menu" @click="toggleMenu">
      <div class="hamburger-icon">
        <div :class="['bar', { open: isMenuOpen }]"></div>
        <div :class="['bar', { open: isMenuOpen }]"></div>
        <div :class="['bar', { open: isMenuOpen }]"></div>
      </div>
    </div>

    <!-- Overlay & Sidebar -->
    <div class="menu-overlay" :class="{ visible: isMenuOpen }" v-if="isMenuOpen" @click="toggleMenu"></div>
    <nav class="sidebar" :class="{ open: isMenuOpen }">
      <ul>
        <li><a href="#" @click.prevent="openGameRules">Game Rules</a></li>
        <li><a href="#" @click.prevent="openDonation">Help us grow</a></li>
        <li><a href="#" @click.prevent="openSuggestionForm">Suggest Question</a></li>
        <li><a href="#" @click.prevent="openFeedbackForm">Feedback Form</a></li>
        <li><a href="#" @click.prevent="openPrivacyPolicy">Privacy Policy</a></li>
        <li class="dark-mode-li">
          <!-- Dark Mode Toggle -->
          <label class="dark-mode-toggle">
            <span>Dark Mode</span>
            <input type="checkbox" v-model="darkMode" @change="updateDarkMode" />
            <span class="toggle-slider"></span>
          </label>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { useStore } from '../store';
import { mapState, mapActions } from 'pinia';

export default {
  computed: {
    ...mapState(useStore, ['isMenuOpen']),
    darkMode: {
      get() {
        return useStore().darkMode;
      },
      set(value) {
        useStore().darkMode = value;
      },
    },
  },
  methods: {
    ...mapActions(useStore, [
      'toggleMenu',
      'openGameRules',
      'openDonation',
      'openSuggestionForm',
      'openFeedbackForm',
      'openPrivacyPolicy',
    ]),
    updateDarkMode() {
      // Save to localStorage and apply the dark mode class to document.body based on current state
      localStorage.setItem('darkMode', JSON.stringify(this.darkMode));
      if (this.darkMode) {
        document.body.classList.add('dark-mode');
      } else {
        document.body.classList.remove('dark-mode');
      }
    },
  },
};
</script>

<style scoped>
.hamburger-menu {
    position: fixed;
    top: 20px;
    right: 20px;
    padding-top: 5vh;
    margin-top: 5vh;
    z-index: 10000;
    padding: 15px;
    transition: transform 0.3s ease;
}

.hamburger-menu:active {
    transform: scale(0.95);
}

.hamburger-icon {
    width: 29px;
    height: 22px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
}

.bar {
    width: 100%;
    height: 4px;
    background-color: var(--raspberry-pink);
    transition: all 0.3s ease;
    border-radius: 2px;
}

.bar.open:nth-child(1) {
    transform: rotate(45deg) translate(4px, 4px);
}

.bar.open:nth-child(2) {
    opacity: 0;
}

.bar.open:nth-child(3) {
    transform: rotate(-45deg) translate(4px, -4px);
}

.sidebar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    max-height: 80vh;
    background-color: white;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 20px;
    z-index: 10001;
    transform: translateY(100%);
    transition: transform 0.3s ease;
}

.sidebar.open {
    transform: translateY(0);
}

.sidebar ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    max-width: 600px;
    margin: 0 auto;
}

.sidebar ul li {
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: center;
}

.sidebar ul li a {
    text-decoration: none;
    color: #333;
    font-size: 20px;
    display: block;
    padding: 5px 0;
    width: 100%;
    text-align: left;
}

.sidebar ul li a:active {
    opacity: 0.7;
}

body.dark-mode .sidebar {
    background-color: var(--background-dark);
}

body.dark-mode .sidebar ul li {
    border-bottom-color: #333;
}

body.dark-mode .sidebar ul li a {
    color: var(--text-dark);
}

.menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.menu-overlay.visible {
    opacity: 1;
}

.dark-mode-toggle {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    font-size: 20px;
    padding: 10px 0;
    width: 100%;
}

.dark-mode-toggle input {
    display: none;
}

.toggle-slider {
    margin-left: 10px;
    width: 40px;
    height: 20px;
    background-color: #ccc;
    position: relative;
    border-radius: 34px;
    transition: background-color 0.2s ease;
}

.toggle-slider:before {
    content: "";
    position: absolute;
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: #fff;
    border-radius: 50%;
    transition: transform 0.2s ease;
}

.dark-mode-toggle input:checked + .toggle-slider {
    background-color: var(--slider-colour);
}

.dark-mode-toggle input:checked + .toggle-slider:before {
    transform: translateX(20px);
}
</style>
